<template>
  <ol class="breadcrumb d-flex">
    <li class="breadcrumb-item" v-for="(item, index) in list"><span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
      <router-link :to="adjustPath(item)" v-else>
        <span @click="hideMobile">{{ showName(item) }}</span>
      </router-link>
    </li>
    <li id="userID" class="float-right align-self-end ml-auto">User ID: {{ username }}</li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      username: this.$store.state.cognito.user.username
    }
  },
  methods: {
    adjustPath (item) {
      return item.path === '' ? '/' : item.path
    },
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    },
    hideMobile () {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue?77e14961